module.exports = __webpack_public_path__ + "d4f48f01c554001a032da51c16709e0d.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/level_1_rustig.mp3
// module id = 74
// module chunks = 0